import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 px-6 bg-white" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <motion.div className="bg-brand-rose/10 p-8 md:p-12 rounded-3xl text-center relative" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-119">
          <Sparkles className="w-10 h-10 text-brand-rose mx-auto mb-6" data-id="element-120" />
          <p className="text-xl md:text-2xl font-heading text-brand-green leading-relaxed italic" data-id="element-121">
            "En los primeros 7 días, lo primero que notarás no es solo la
            báscula, sino cómo tus manos se sienten más ligeras, tu rostro
            recupera su definición y esa niebla mental del mediodía desaparece
            por completo."
          </p>
        </motion.div>
      </div>
    </section>;
}